import { BOOKING_COMMENTS, BACKPAGE_TO_REDIRECT, PNR_HISTORY, MANIFEST_DETAILS, SET_SIDEMENU_FLAG } from './SideMenuType';

const initialStateSearch={
    CommentsForCurrentBooking: [],
    redirectionPage: '/Search',
    pnrHistory: null,
    manifestDetails: null,
    sideMenuFlag: false
}

const sideMenuReducer =(state=initialStateSearch,action)=>
{
    switch(action.type)
    {
        case BOOKING_COMMENTS: return{
            ...state,
            CommentsForCurrentBooking:action.CommentsForCurrentBooking
        }
        case BACKPAGE_TO_REDIRECT: return{
            ...state,
            redirectionPage:action.redirectionPage
        }
        case PNR_HISTORY: return {
            ...state,
            pnrHistory:action.pnrHistory
        }
        case MANIFEST_DETAILS: return {
            ...state,
            manifestDetails: action.manifestDetails
        }
        case SET_SIDEMENU_FLAG: return {
            ...state,
            sideMenuFlag: action.sideMenuFlag
        }
        default: return state
    }
}

export default sideMenuReducer;